import {RadioButton} from 'react-native-paper';
import {useTheme} from 'styled-components';
import JustBottomBorderTextInput from './JustBottomBorderTextInput';
import PhoneView from './PhoneView';
import SimpleText from './SimpleText';

const CommonRadioButton = props => {
  const theme = useTheme();

  return (
    <PhoneView
      className="myView custom-radio"
      style={
        props.style
          ? {
              ...{height: props.isCheckBox ? 20 : 60, alignItems: 'center'},
              ...props.style,
            }
          : {height: props.isCheckBox ? 20 : 60, alignItems: 'center'}
      }>
      {props.isCheckBox === undefined && (
        <RadioButton
          value={props.value}
          status={props.status}
          onPress={props.onPress}
          theme={{
            colors: {
              primary: theme.colors.primary,
              surface: theme.colors.primary,
              backdrop: theme.colors.primary,
              accent: theme.colors.primary,
              background: theme.colors.primary,
              error: theme.colors.primary,
              onBackground: theme.colors.primary,
              placeholder: theme.colors.primary,
            },
          }}
        />
      )}
      {props.isCheckBox !== undefined && (
        <input
          type="checkbox"
          onChange={props.onPress}
          checked={props.status === 'checked'}
        />
      )}

      {(props.type === undefined || props.type === 'simple') && (
        <SimpleText
          style={
            props.textStyle
              ? props.textStyle
              : {
                  color:
                    props.style === undefined || props.style.color === undefined
                      ? theme.colors.primary
                      : props.style.color,
                  alignSelf: 'center',
                }
          }
          text={props.text}
        />
      )}
      {props.type !== undefined && props.type === 'textInput' && (
        <JustBottomBorderTextInput
          onChangeText={props.onChangeText}
          justNum={props.justNum}
          placeholder={props.text}
          subText={props.text}
          disable={props.disable}
          value={props.textValue}
        />
      )}
    </PhoneView>
  );
};

export default CommonRadioButton;
